import React, { FC, useEffect, useState } from "react";
import styles from "./PerguntasFrequentes.module.scss";
import Arrow_Down from "./../../../../Static/Images/Icones/arrow_down.png";
import { Link } from "react-scroll";
import { isMobile } from "react-device-detect";

export const PerguntasFrequentes: FC = () => {
  const [perguntas, setPerguntas] = useState<
    { title: string; text: any; isOpen: boolean; id: number }[]
  >([]);

  useEffect(() => {
    setPerguntas([
      {
        title: "Oque é QueroVet?",
        text: "O Quero Vet é um aplicativo de atendimento veterinário em domicílio. O veterinário vai até sua residência atender seu pet.",
        id: 8,
        isOpen: false,
      },
      {
        title: "Quais serviços o QueroVet presta?",
        text: "O QueroVet oferece consultas domiciliares em horário comercial, plantão, vacinas e vermifugos. Todos esses serviços são solicitados pelo aplicativo e realizados em sua residência.",
        id: 9,
        isOpen: false,
      },
      {
        title: "Oque os planos VetSaude oferecem?",
        text: "Os planos lhe oferecem consultas domiciliares em horário comercial, plantão, vacinas e vermifugos.",
        id: 1,
        isOpen: false,
      },
      {
        title: "Como adquiro um plano VetSaude?",
        text: (
          <p>
            Através do nosso
            <Link to={"planos"} spy={true} smooth={true} duration={500}>
              &nbsp;Site&nbsp;
            </Link>
            ou com um dos nossos consultores de vendas
          </p>
        ),
        id: 2,
        isOpen: false,
      },
      {
        title: "Quantos pets posso por no plano Vet saúde?",
        text: "Temos planos limitados atrelados ao CPF que podem ser compartilhados entre todos os seus animais e também planos individuais ilimitados.",
        id: 3,
        isOpen: false,
      },
      {
        title: "Qual a forma de pagamento do plano VetSaude?",
        text: "à vista no Boleto bancário e Pix ou em até 12x sem juros no Cartão de crédito.",
        id: 4,
        isOpen: false,
      },
      {
        title: "Posso cancelar meu plano VetSaude?",
        text: "Sim, é possível fazer o cancelamento a qualquer momento mediante solicitação (consultar nossos termos de adesão). Porém o contrato é de 6 a 12 meses, dependendo do plano contratado, com renovação automática depois desse prazo.",
        id: 5,
        isOpen: false,
      },
      {
        title: "Oque é essa co-participação dos planos VetSaude?",
        text: "A coparticipação é uma porcentagem que você paga dos serviços quando você os utilizar, a fim de reduzir seus custos com a mensalidade, para o de caso não utilizar todo o plano.",
        id: 6,
        isOpen: false,
      },
      {
        title: "Posso montar meu plano VetSaude personalizado?",
        text: "Sim, caso esteja em busca de mais serviços além do que oferecemos nos planos, poderá montar um plano que atenda a necessidades dos seus pets, com mais consultas, vacinas e vermifugos",
        id: 7,
        isOpen: false,
      },
      {
        title: "Como funciona se precisar de exames ou internações?",
        text: "Atualmente nossos planos disponíveis não contemplam serviços além das consultas em horário comercial e plantão, vacinas e vermífugos. Mas não se preocupe, em todas as cidades onde o QueroVet está disponível, temos clínicas e equipes de confiança para os demais serviços que forem necessários.",
        id: 10,
        isOpen: false,
      },
      {
        title: "Como saber qual veterinário vai atender meu pet?",
        text: "No momento da solicitação, você pode escolher qual veterinário prefere para lhe atender e respectivos valores.",
        id: 11,
        isOpen: false,
      },
      {
        title: "O aplicativo QueroVet é gratuito?",
        text: "Sim, para baixar o aplicativo QueroVet é gratuito, está disponível para Android e IOS. Os valores dos serviços oferecidos dentro do aplicativo ficam acessíveis antes da solicitação de atendimento.",
        id: 12,
        isOpen: false,
      },
    ]);
  }, []);

  return (
    <div
      className={`${styles["PerguntasFrequentes"]}  ${
        isMobile ? styles["mobile"] : ""
      }`}
    >
      <div className={styles["Content"]}>
        <span className={styles["Title-Page"]}>Perguntas Frequentes</span>
        {perguntas.map((item, idx) => {
          return (
            <div key={`ask-${idx}`} className={styles["Question"]}>
              <a
                onClick={() => {
                  const findItem = perguntas.findIndex((x) => x.id === item.id);
                  if (findItem !== -1) {
                    const wasOpen = perguntas[findItem].isOpen;
                    let newPerguntas = perguntas.map((x) => {
                      x.isOpen = false;
                      return x;
                    });
                    newPerguntas[findItem].isOpen = wasOpen
                      ? false
                      : !newPerguntas[findItem].isOpen;
                    setPerguntas([...newPerguntas]);
                  }
                }}
                className={styles["Item"]}
              >
                <span className={styles["Title"]}>{item.title}</span>
                <img
                  className={`${
                    item.isOpen ? styles["open"] : styles["close"]
                  }`}
                  src={Arrow_Down}
                />
              </a>
              <span
                className={`${styles["Text"]} ${
                  item.isOpen ? styles["open"] : styles["closed"]
                }`}
              >
                {item.text}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
